import {
  GET_COUNTRY_DROPDOWN,
  SET_COUNTRY_DROPDOWN,
  GET_BRANCH_VALUES,
  SET_BRANCH_VALUES,
  SET_RESULT_MESSAGE,
  GET_USER_DETAIL,
  SET_USER_DETAIL,
  SET_USER_DETAIL_EXTERNAL,
  GET_USER_DETAIL_EXTERNAL,
  SET_BRANCH
} from './types';

const getCountryDropdown = () => {
  return {
    type: GET_COUNTRY_DROPDOWN
  }
}

const setCountryDropdown = (countryDropdown: any) => {
  return {
    type: SET_COUNTRY_DROPDOWN,
    countryDropdown
  }
}
const getBranchValues = () => {
  return {
    type: GET_BRANCH_VALUES,
  }
}

const setBranchValues = (value: any) => {
  return {
    type: SET_BRANCH_VALUES,
    value
  }
}

export const SetBranch = (BranchList: any) => {
  return {
    type: SET_BRANCH,
    payload: BranchList,
  };
};

const getUserDetails = (user: any) => {
  return {
    type: GET_USER_DETAIL,
    user
  }
}
const setUserDetails = (value: any) => {
  return {
    type: SET_USER_DETAIL,
    value
  }
}
const getUserDetailsExternal = (value: any) => ({
  type: GET_USER_DETAIL_EXTERNAL,
  value
})

const setUserDetailsExternal = (value: any) => {
  return {
    type: SET_USER_DETAIL_EXTERNAL,
    value
  }
}
const setResultMessage = (value: string) => {
  return {
    type: SET_RESULT_MESSAGE,
    value
  }
}

export {
  getBranchValues,
  setBranchValues,
  setResultMessage,
  getUserDetails,
  setUserDetails,
  getCountryDropdown,
  setCountryDropdown,
  setUserDetailsExternal,
  getUserDetailsExternal
}

export default {
  getBranchValues,
  setBranchValues,
  setResultMessage,
  getUserDetails,
  setUserDetails,
  getCountryDropdown,
  setCountryDropdown,
  setUserDetailsExternal,
  getUserDetailsExternal,
  SetBranch
}